import { Helmet } from 'react-helmet-async'

export default function SEO({
  title = 'CTE Course Platform - AI Prompting & Agent Systems',
  description = 'Master AI Prompting and Agent Systems with OpenAI Assistants. Build production-ready agents you can ship.',
  url = 'https://www.mytechcourses.com/',
  image = 'https://www.mytechcourses.com/branding/cte-course-platform-icon.svg',
  type = 'website',
  twitterCard = 'summary_large_image',
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  )
}

